"use strict";

var LoggerInstance = require("js-logger").get("PaymentTerms");

var PaymentTermsApi = require("../api/PaymentTermsApi");

var Constants = require("../designer/Constants");

var paymentTermsPopupSelector = "[data-component='paymentTerms']";
var paymentTermsAddToCart = "[data-component='paymentTerms.locationSpecificText.addToCart']";
var paymentTermsOnePageCheckout = "[data-component='paymentTerms.locationSpecificText.onePageCheckout']";
var paymentTermsMySubscriptions = "[data-component='paymentTerms.locationSpecificText.mySubscriptions']";
var paymentTermsHtmlSelector = "[data-dynamic='paymentTerms']";
var paymentTermsCancelSelector = ".paymentTerms-abort";
var paymentTermsSubmitSelector = ".paymentTerms-submit";

var PaymentTermsHelper = {
	initialize: function (options) {
		options = options || {};

		this._getPaymentTermsConfigurationDeferred = new $.Deferred();

		if (options.isPaymentTermsWizardComplete) {
			this._getPaymentTermsControlRecord().done((paymentTermsEnabledValue) => {
				if (paymentTermsEnabledValue === "Y") {
					var themeId = $("body").attr("data-theme");

					if (themeId) {
						PaymentTermsApi.getPaymentTermsHtml(themeId).done((data) => {
							if (data.success) {
								this.paymentTermsModalHtml = data.model.paymentTermsHtml;
								this._getPaymentTermsConfigurationDeferred.resolve(true)
							} else {
								this._getPaymentTermsConfigurationDeferred.resolve(false);
							}
						});
					} else {
						LoggerInstance.warn("ThemeId was not specified in the body tag.");
						this._getPaymentTermsConfigurationDeferred.resolve(false);
					}
				} else {
					LoggerInstance.info("Payment terms are not enabled from Control Record.");
					this._getPaymentTermsConfigurationDeferred.resolve(false);
				}
			}).fail(() => {
				LoggerInstance.warn("Failed to initialize payment terms.");
				this._getPaymentTermsConfigurationDeferred.resolve(false);
			});
		} else {
			LoggerInstance.info("The Payment Terms Note Type Configuration wizard is not complete.");
			this._getPaymentTermsConfigurationDeferred.resolve(false);
		}
	},

	showPaymentTermsModal(deferred, tangible, type) {
		if (!this.paymentTermsModalHtml) {
			LoggerInstance.warn("Payment terms modal HTML is not available.");
			return;
		}

		var html = $(this.paymentTermsModalHtml);
		var $popup = $(html).hide().appendTo("body");

		$popup.find(paymentTermsHtmlSelector).each((index, element) => {
			var $htmlComponent = $(element);

			$htmlComponent.html(tangible.PaymentTermsText);
		});

		$popup.find(paymentTermsHtmlSelector).addBack(paymentTermsHtmlSelector).css({ overflow: "auto" });

		if (type == Constants.PAYMENT_TERMS_TYPES.ADD_TO_CART) {
			$popup.find(paymentTermsAddToCart).show();
			$popup.find(paymentTermsOnePageCheckout).hide();
			$popup.find(paymentTermsMySubscriptions).hide();
		} else if (type == Constants.PAYMENT_TERMS_TYPES.ONE_PAGE_CHECKOUT) {
			$popup.find(paymentTermsAddToCart).hide();
			$popup.find(paymentTermsOnePageCheckout).show();
			$popup.find(paymentTermsMySubscriptions).hide();
		} else if (type == Constants.PAYMENT_TERMS_TYPES.MY_SUBSCRIPTIONS) {
			$popup.find(paymentTermsAddToCart).hide();
			$popup.find(paymentTermsOnePageCheckout).hide();
			$popup.find(paymentTermsMySubscriptions).show();
		}

		$popup.show();

		// Disable scrolling on the page behind the popup
		this._lockBodyScroll();

		//Adding Click Events
		$popup.find(paymentTermsCancelSelector).click(() => {
			//Constituent did not agree to the terms.
			this._removePopup($popup);
			deferred.resolve(false);
		});

		$popup.find(paymentTermsSubmitSelector).click(() => {
			//Constituent has agreed to the terms.
			this._removePopup($popup);
			deferred.resolve(true);
		});

		//Escape linked to go back.
		$(document).on("keydown", { $popup }, this._popupEscapeHandler);

		$popup.find("[data-component='help']").off("click.pinModal").on("click.pinModal", function (event) {
			window.showPinModal();
		});
	},

	_popupEscapeHandler(event) {
		if (!event || !event.data) {
			LoggerInstance.error("Event or Event Data not present in Popup Escape Handler");
			return;
		}

		if (event.which == Constants.KEYS.ESCAPE) {
			$(event.data.$popup).find(paymentTermsCancelSelector).click();
		}
	},

	_removePopup($popup) {
		$(document).off("keydown", this._popupEscapeHandler);
		$popup.remove();

		// Re-enable scrolling on the page behind the popup
		this._unlockBodyScroll();
	},

	_lockBodyScroll() {
		// Capture the current body width (outside of the scrollbar width) to keep it the same
		// when locking it in place since the scrollbar will disappear
		const bodyWidth = document.body.getBoundingClientRect().width;

		// Capture the current veritcal scroll position so it can be restored later
		const scrollY = window.scrollY;

		// Lock the body in place by setting its position to fixed
		document.body.style.position = 'fixed';
		document.body.style.top = `-${scrollY}px`;
		document.body.style.left = '0';
		document.body.style.right = '0';
		document.body.style.width = `${bodyWidth}px`;

		document.body.setAttribute('data-scroll-y', scrollY);
	},

	_unlockBodyScroll() {
		const scrollY = document.body.getAttribute('data-scroll-y');
		document.body.removeAttribute('data-scroll-y');

		document.body.style.position = '';
		document.body.style.top = '';
		document.body.style.left = '';
		document.body.style.right = '';
		document.body.style.width = '';

		window.scrollTo(0, parseInt(scrollY || '0', 10));
	},

	_getPaymentTermsControlRecord: function () {
		var deferred = new $.Deferred();

		if (this.paymentTermsEnabled) {
			deferred.resolve(this.paymentTermsEnabled);
		} else {
			PaymentTermsApi.getPaymentTermsControlRecord().done((paymentTermsEnabled) => {
				this.paymentTermsEnabled = paymentTermsEnabled.value;
				deferred.resolve(this.paymentTermsEnabled);
			}).fail((err) => {
				LoggerInstance.info("Unable to get payment terms control record.");
				deferred.reject();
			});
		}

		return deferred;
	},

	arePaymentTermsConfigured: function () {
		return this._getPaymentTermsConfigurationDeferred;
	}
};

module.exports = PaymentTermsHelper;
